// What made up ProjectMetrics.HealthScore, as written by the metrics lambda (NK-446).
export interface HealthBreakdownItem {
  key: string;
  label: string;
  state?: string;     // flag state (Watch / Alert); absent for the CID and IR terms
  points: number;
  actual?: number;    // percentages, when the term compares a rate to an expectation
  expected?: number;
}

export interface HealthBreakdown {
  score: number;
  computedAt: string;
  reason?: string;    // why the score is 0 with no items, e.g. belowMinStarts
  items: HealthBreakdownItem[];
}

export function parseHealthBreakdown(json: string | null | undefined): HealthBreakdown | null {
  if (!json) return null;
  try {
    const parsed = JSON.parse(json);
    return parsed && Array.isArray(parsed.items) ? parsed as HealthBreakdown : null;
  } catch {
    return null;
  }
}
